import { useMemo } from 'react';

import { IconLabel, IconLabelList } from '@/components/ui/IconLabel';
import { Stack } from '@/components/ui/Stack';
import { Heading } from '@/components/ui/Text';
import { mapHouseRules } from '@/lib/houseRules';
import { useI18n } from '@/locales';
import type { IRestriction } from '@/types/content';

interface HouseRulesProps {
	restrictions: IRestriction[];
	checkIn: string;
	checkOut: string;
}

export const HouseRules = ({
	restrictions,
	checkIn,
	checkOut,
}: HouseRulesProps) => {
	const t = useI18n();
	const rules = useMemo(
		() => mapHouseRules(restrictions, checkIn, checkOut),
		[restrictions, checkIn, checkOut],
	);

	return (
		<Stack gap="space30">
			<Heading as="h2" size="md">
				{t('property.houseRules.title')}
			</Heading>
			<IconLabelList>
				{rules.map((rule) => (
					<IconLabel
						key={rule.key}
						icon={rule.icon}
						label={rule.label}
					/>
				))}
			</IconLabelList>
		</Stack>
	);
};
